import { z } from 'zod';
import { requiredStreetAddress } from '@trashlab/api/src/domains/core/validation/address-schema';
import {
  phoneNumberSchema,
  requiredPhoneNumberSchema,
} from '@trashlab/api/src/domains/core/validation/phone-number-schema';

const submitInformation = z.object({
  cartId: z.uuid(),
  tenantId: z.uuid(),
  customerNotes: z.string().optional(),
  siteAddress: requiredStreetAddress,
  containerRotation: z.number().default(0),
  attachments: z
    .array(
      z.object({
        fileId: z.uuid(),
        url: z.string(),
        type: z.string(),
        notes: z.string(),
      }),
    )
    .optional(),
  materialId: z.uuid(),
  wasteGeneratorCategory: z.enum(['RESIDENTIAL', 'COMMERCIAL']),
});

export const websiteGoBackAStepSchema = z.object({
  cartId: z.uuid(),
  tenantId: z.uuid(),
});

const submitContact = z
  .object({
    cartId: z.uuid(),
    tenantId: z.uuid(),
    customerAddress: z.object({
      streetAddressPartOne: z.string(),
      streetAddressPartTwo: z.string(),
      city: z.string(),
      state: z.string(),
      postalCode: z.string(),
    }),
    customerEmail: z.string(),
    customerName: z.string().min(1),
    customerPhoneNumber: phoneNumberSchema,
  })
  .refine(
    (data) => {
      return (
        data.customerPhoneNumber !== null &&
        data.customerPhoneNumber !== undefined &&
        data.customerPhoneNumber !== ''
      );
    },
    {
      message: 'Customer phone number is required',
      path: ['customerPhoneNumber'],
    },
  );

export default {
  submitInformation,
  websiteGoBackAStepSchema,
  submitContact,
};
